export const documentStates = [
  { value: 'ACCEPTED', text: 'doc_state.accepted', icon: 'mdi-check-circle-outline', color: 'success' },
  { value: 'WAITING', text: 'doc_state.waiting', icon: 'mdi-clock-check-outline', color: 'warning' },
  { value: 'REJECTED', text: 'doc_state.rejected', icon: 'mdi-close-circle-outline', color: 'error' },
]

export type DocumentState = typeof documentStates[number]['value']

const mapDocumentStates : Map<string, string> = new Map()
documentStates.forEach((e) => {
  mapDocumentStates.set(e.value, e.text)
})

export function getDocumentStateLabel(key : DocumentState) : string {
  return key && mapDocumentStates.get(key) || ''
}

const mapDocumentStateIcons : Map<string, { icon: string, color: string }> = new Map()
documentStates.forEach((e) => {
  mapDocumentStateIcons.set(e.value, { icon: e.icon, color: e.color })
})

export function getDocumentStateIcon(key : DocumentState) : { icon: string, color: string } {
  return key && mapDocumentStateIcons.get(key) || { icon: '', color: '' }
}
